module.exports = __webpack_public_path__ + "static/media/cameraToken.bbaa5f7f.svg";